(function () {
  'use strict';

  function init(root) {
    if (!root || root.dataset.fccInit) return;
    root.dataset.fccInit = '1';

    var pills = Array.prototype.slice.call(root.querySelectorAll('[data-fcc-pill]'));
    var sections = Array.prototype.slice.call(root.querySelectorAll('[data-fcc-group]'));
    var anchor = root.querySelector('[data-fcc-anchor]');
    if (!pills.length || !sections.length) return;

    function filter(target, doScroll) {
      pills.forEach(function (p) {
        p.classList.toggle('is-active', p.getAttribute('data-fcc-target') === target);
      });
      sections.forEach(function (s) {
        var match = target === 'all' || s.getAttribute('data-fcc-group') === target;
        s.classList.toggle('is-hidden', !match);
      });
      if (doScroll && anchor) {
        var bar = root.querySelector('.fcc-pillbar');
        var offset = (bar ? bar.getBoundingClientRect().height : 0) + 12;
        var y = anchor.getBoundingClientRect().top + window.pageYOffset - offset;
        if (y < window.pageYOffset) {
          window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
        }
      }
    }

    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        filter(pill.getAttribute('data-fcc-target'), true);
      });
    });

    filter('all', false);
  }

  function boot() {
    document.querySelectorAll('.firme-cc').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Theme editor: re-init when the section is (re)loaded
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector ? e.target.querySelector('.firme-cc') : null;
    if (root) { delete root.dataset.fccInit; init(root); }
  });
})();
